import Actions from "../../actions";
import * as requestFromServer from "./walletTransactionsApis";

// wallet transactions -> get wallet transactions  api
export const getWalletTransactionsAction =
  (dataToBeSent) => async (dispatch) => {
    const response = await requestFromServer.getWalletTransactions(
      dataToBeSent
    );
    if (response) {
      dispatch(
        Actions.createAction(Actions.GET_WALLET_TRANSACTIONS_LIST, {
          walletTransactions: response,
        })
      );
      return response;
    }
  };
